"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverConsole = exports.serverOnly = exports.ServerOnly = void 0;
const isomorphic_1 = require("../../isomorphic");
class ServerOnly {
    constructor(value) {
        this.value = value;
    }
    toJSON() {
        return {};
    }
}
exports.ServerOnly = ServerOnly;
const serverOnly = (value) => new ServerOnly(value);
exports.serverOnly = serverOnly;
exports.serverConsole = {
    log: isomorphic_1.LOGGER.info,
    debug: isomorphic_1.LOGGER.debug,
    info: isomorphic_1.LOGGER.info,
    warn: isomorphic_1.LOGGER.warn,
    error: isomorphic_1.LOGGER.error
};
